export default __webpack_public_path__ + "static/media/calender-white.9d476acb.svg";